import { Dispatch } from 'react';
import { Action, Reducer } from 'redux';
import { MeitnerSchoolUnitResponse, MeitnerExportEnvironmentType } from '../models/CoreMeitnerModels';
import InstanceClient from '../services/InstanceClient';
import { RequestState } from '../models/RequestState';
import StatusCode from '../util/StatusCode';

enum MeitnerExportType {
    GET_MEITNER_SCHOOLUNITS = 'GET_MEITNER_SCHOOLUNITS',
}

export interface MeitnerExportState {
    meitnerSchoolUnits: RequestState<MeitnerSchoolUnitResponse>
}

interface MeitnerExport_MeitnerSchoolUnits extends Action<MeitnerExportType> {
    type: MeitnerExportType.GET_MEITNER_SCHOOLUNITS,
    meitnerSchoolUnits: RequestState<MeitnerSchoolUnitResponse>
}

type MeitnerExportAction = MeitnerExport_MeitnerSchoolUnits

export const GetMeitnerSchoolUnits = (clientId: string, clientSecret: string, environment: MeitnerExportEnvironmentType) => (dispatch: Dispatch<MeitnerExport_MeitnerSchoolUnits>) => {
    dispatch({
        type: MeitnerExportType.GET_MEITNER_SCHOOLUNITS,
        meitnerSchoolUnits: { code: StatusCode.PENDING }
    })

    InstanceClient.get<MeitnerSchoolUnitResponse>("/api/core/meitnerexport/schoolUnits", { clientId, clientSecret, environment })
        .then(res => {
            dispatch({
                type: MeitnerExportType.GET_MEITNER_SCHOOLUNITS,
                meitnerSchoolUnits: {
                    code: StatusCode.COMPLETE,
                    data: res.data
                }
            })
        })
        .catch(error => {
            dispatch({
                type: MeitnerExportType.GET_MEITNER_SCHOOLUNITS,
                meitnerSchoolUnits: { code: StatusCode.ERROR, error }
            })
        })
}

const initialState: MeitnerExportState = {
    meitnerSchoolUnits: { code: StatusCode.NONE }
}

export const reducer: Reducer<MeitnerExportState, MeitnerExportAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case MeitnerExportType.GET_MEITNER_SCHOOLUNITS:
            return {
                ...state,
                meitnerSchoolUnits: action.meitnerSchoolUnits
            }
        default:
            return state;
    }
}